import { reduce } from "robot3";

import { initialContext } from "./constants";
import { calculateNewSlideIndex } from "./guards";

export const slideChangedReducer = reduce(
  (ctx, { slideIndex, currentBudgetCategory }) => ({
    ...ctx,
    currentSlideIndex: slideIndex ?? ctx.currentSlideIndex,
    currentBudgetCategory: currentBudgetCategory ?? ctx.currentBudgetCategory,
  }),
);

export const completeReducer = reduce((ctx) => ({
  ...ctx,
  currentSlideIndex: ctx.totalSlides - 1,
}));

export const navigateReducer = reduce((ctx, event) => {
  return {
    ...ctx,
    currentSlideIndex: calculateNewSlideIndex(ctx, event),
  };
});

export const optionAddedReducer = reduce((ctx, { budgetPlan }) => ({
  ...ctx,
  budgetPlan,
}));

export const regionalTaxRateChangedReducer = reduce(
  (ctx, { regionalIncomeTaxRate }) => ({
    ...ctx,
    regionalIncomeTaxRate,
  }),
);

export const startOverReducer = reduce(
  ({
    budgetCategories,
    budgetCategoriesLoaded,
    slideConfigs,
    totalSlides,
  }) => ({
    ...initialContext,
    budgetCategories,
    budgetCategoriesLoaded,
    slideConfigs,
    totalSlides,
  }),
);

export const planCreationFailedReducer = reduce(
  (ctx, { planCreationError }) => ({
    ...ctx,
    planCreationError,
  }),
);
